export default class RoleService {

    static isAdmin() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if(user === null){
            return false;
        }
        if(user.nivelAcesso.id == 1){
            return true;
        }else {
            return false;
        } */
    }

    static isWhiteLabel() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if (user.nivelAcesso.id == 5) {
            return true;
        } else {
            return false;
        } */
    }

    static isColaborador() {
        return false;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if (user.nivelAcesso.id != 1 && user.nivelAcesso.id != 5) {
            return true;
        } else {
            return false;
        } */
    }

    podeSimulador() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 2)) {
            return true;
        }

        return false; */

    }

    podeRetorno() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if (user.nivelAcesso.id == 5 && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 4)) {
            return true;
        }

        return false; */
    }

    podeCartaoDeCredito() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 5)) {
            return true;
        }

        return false; */
    }

    podeLojas() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 6)) {
            return true;
        }

        return false; */
    }

    podeColaboradores() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 7)) {
            return true;
        }

        return false; */
    }

    podeMarcas() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 8)) {
            return true;
        }

        return false; */
    }

    podeCores() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 9)) {
            return true;
        }

        return false; */
    }

    podeFamilias() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 10)) {
            return true;
        }

        return false; */
    }

    podeModelos() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 11)) {
            return true;
        }

        return false; */
    }

    podeAcessorios() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 12)) {
            return true;
        }

        return false; */
    }

    podeGarantiaEstendida() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 13)) {
            return true;
        }

        return false; */
    }


    podeVendas() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if (user.nivelAcesso.id == 1 && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 14)) {
            return true;
        }

        return false; */
    }

    podeTipoEmplacamento() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 15)) {
            return true;
        }

        return false; */
    }

    podeFormaPagamento() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 16)) {
            return true;
        }

        return false; */
    }


    podeFinanceiras() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 17)) {
            return true;
        }

        return false; */
    }

    podePlanos() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 18)) {
            return true;
        }

        return false; */
    }

    podeStatusVenda() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 19)) {
            return true;
        }

        return false; */
    }



    podeGrupos() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if ((user.nivelAcesso.id == 1 || user.nivelAcesso.id == 5) && user.grupo == null) {
            return true;
        } else if (user.grupo != null && user.grupo.roles.find(role => role.id == 20)) {
            return true;
        }

        return false; */
    }

    podeWhiteLabel() {
        return true;
        /* let user = JSON.parse(localStorage.getItem('user'));
        if (user === null) {
            return false;
        }
        if (user.nivelAcesso.id == 1) {
            return true;
        }

        return false; */
    }

    menuItems() {
        let menu = [];
        let roles = JSON.parse(localStorage.getItem('roles'));
        let idUser = JSON.parse(localStorage.getItem('idUser'));
        let idEmpresa = JSON.parse(localStorage.getItem('idEmpresa'));
        let idPrestador = JSON.parse(localStorage.getItem('idPrestador'));

        if (this.podeSimulador()) {
            menu.push({ label: 'Inicio', icon: 'pi pi-home', items: [] });
            menu[menu.length - 1].items.push({ label: 'Início', icon: 'pi pi-th-large', to: '/' });
        }
        /* if (this.podeRetorno() || this.podeCartaoDeCredito()) {
            let items = [];
            if (this.podeCartaoDeCredito()) {
                items.push({ label: 'Cartão de crédito / débito', icon: 'pi pi-credit-card', to: '/tabelas/cartaoDeCredito/listar' });
            }
            if (this.podeRetorno()) {
                items.push({ label: 'Retorno', icon: 'pi pi-credit-card', to: '/tabelas/retorno/listar' });
            }
            menu.push({
                label: 'Tabelas', icon: 'pi pi-table', items: items
            });
        }*/

        if (roles.grupoCadastro) {
            menu.push({ label: 'Cadastros', icon: 'pi pi-pencil', items: [] });

            if (roles.listAllEmpresa) {
                menu[menu.length - 1].items.push({ label: 'Empresas', icon: 'pi pi-briefcase', to: '/empresa/listar' });
            } else if (roles.getEmpresa) {
                menu[menu.length - 1].items.push({ label: 'Empresa', icon: 'pi pi-briefcase', to: `/empresa/editar/${idEmpresa}` });
            }

            if (roles.uploadImage)
                menu[menu.length - 1].items.push({ label: 'Imagens', icon: 'pi pi-briefcase', to: '/imagem/cadastrar' });
            /* if (roles.listAllPrestadores || (roles.listAllPrestadoresByCompany && roles.isEmpresaAdm)) {
                menu[menu.length - 1].items.push({ label: 'Prestadores', icon: 'pi pi-briefcase', to: '/prestador/listar' });
            } else if (roles.getPrestador) {
                menu[menu.length - 1].items.push({ label: 'Prestador', icon: 'pi pi-briefcase', to: `/prestador/editar/${idPrestador}` });
            } */

            /* if (roles.listAllTipoPrestador) {
                menu[menu.length - 1].items.push({ label: 'Tipo Prestador', icon: 'pi pi-briefcase', to: '/prestador/tipo/listar' });
            } */

            /* if (roles.listAllAgendaPrestador || (roles.listAllAgendaPrestadorByCompany && roles.isEmpresaAdm)) {
                menu[menu.length - 1].items.push({ label: 'Agenda', icon: 'pi pi-calendar', to: '/agenda/listar' });
            } else if (roles.listAllAgendaPrestadorByPrestador) {
                menu[menu.length - 1].items.push({ label: 'Agenda', icon: 'pi pi-calendar', to: `/agenda/prestador/listar/${idPrestador}` });
            } */

            /* if (roles.listAllAgendamento || (roles.listAllAgendamentoByCompanyPrestador && roles.isEmpresaAdm)) {
                menu[menu.length - 1].items.push({ label: 'Agendamento', icon: 'pi pi-calendar', to: '/agendamento/listar' });
            } else if (roles.listAllAgendamentoByPrestador) {
                menu[menu.length - 1].items.push({ label: 'Agendamento', icon: 'pi pi-calendar', to: `/agendamento/prestador/${idPrestador}` });
            } */

            /* if (roles.listAllTipoAgendamento) {
                menu[menu.length - 1].items.push({ label: 'Tipo Agendamento', icon: 'pi pi-calendar', to: '/agendamento/tipo/listar' });
            } */

            if (roles.listAllUsers || (roles.listAllUsersByCompany && roles.isEmpresaAdm)) {
                menu[menu.length - 1].items.push({ label: 'Usuarios', icon: 'pi pi-user', to: '/usuarios/listar' });
            }
            /* if (this.podeCores()) {
                menu[menu.length - 1].items.push({ label: 'Cores', icon: 'pi pi-palette', to: '/cadastro/cor/listar' });
            }
            if (this.podeFamilias()) {
                menu[menu.length - 1].items.push({ label: 'Famílias', icon: 'pi pi-slack', to: '/cadastro/familia/listar' });
            }
            if (this.podeFinanceiras()) {
                menu[menu.length - 1].items.push({ label: 'Financeiras', icon: 'pi pi-dollar', to: '/cadastro/financeira/listar' });
            }
            if (this.podeFormaPagamento()) {
                menu[menu.length - 1].items.push({ label: 'Formas de pagamento', icon: 'pi pi-align-justify', to: '/cadastro/formaDePagamento/listar' });
            }
            if (this.podeGarantiaEstendida()) {
                menu[menu.length - 1].items.push({ label: 'Garantia estendida', icon: 'pi pi-hashtag', to: '/cadastro/garantiaEstendida/listar' });
            }
            if (this.podeLojas()) {
                menu[menu.length - 1].items.push({ label: 'Lojas', icon: 'pi pi-home', to: '/cadastro/lojas/listar' });
            }
            if (this.podeMarcas()) {
                menu[menu.length - 1].items.push({ label: 'Marcas', icon: 'pi pi-book', to: '/cadastro/marca/listar' });
            }
            if (this.podeModelos()) {
                menu[menu.length - 1].items.push({ label: 'Modelos', icon: 'pi pi-car', to: '/cadastro/modelo/listar' });
            }
            if (this.podePlanos()) {
                menu[menu.length - 1].items.push({ label: 'Planos', icon: 'pi pi-bars', to: '/cadastro/plano/listar' });
            }
            if (this.podeStatusVenda()) {
                menu[menu.length - 1].items.push({ label: 'Status de venda perdida', icon: 'pi pi-bell', to: '/cadastro/svp/listar' });
            }
            if (this.podeTipoEmplacamento()) {
                menu[menu.length - 1].items.push({ label: 'Tipos de emplacamento', icon: 'pi pi-box', to: '/cadastro/tipoEmplacamento/listar' });
            } */

        }

        if (roles.admin) {
            menu.push({ label: 'Configurações', icon: 'pi pi-pencil', items: [] });
            /* menu[menu.length - 1].items.push({ label: 'Parâmetros', icon: 'pi pi-cog', to: '/configs/listar' }); */

            if (roles.listAllRoles)
                menu[menu.length - 1].items.push({ label: 'Perfis de acesso', icon: 'pi pi-lock-open', to: '/roles/listar' });
        }

        if (roles.listAllNotifications) {
            menu.push({ label: 'Notificações', icon: 'pi pi-pencil', items: [] });

            menu[menu.length - 1].items.push({ label: 'Push Notification', icon: 'pi pi-lock-open', to: '/notificacoes/listar' });
        }

        /* if (roles.listAllPagamento || roles.listAllPagamentoByCompany || roles.listPagamentosByPrestador) {
            menu.push({ label: 'Financeiro', icon: 'pi pi-chart-line', items: [] });
            if (roles.listAllPagamento || (roles.listAllPagamentoByCompany && roles.isEmpresaAdm)) {
                menu[menu.length - 1].items.push({ label: 'Pagamentos', icon: 'pi pi-receipt', to: '/pagamento/listar' });
            } else {
                menu[menu.length - 1].items.push({ label: 'Pagamentos', icon: 'pi pi-receipt', to: `/pagamento/prestador/listar/${idPrestador}` });
            }
        } */

        return menu;
    }

}
